import * as React from "react";
import Button from "@mui/material/Button";
import CssBaseline from "@mui/material/CssBaseline";
import TextField from "@mui/material/TextField";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Container from "@mui/material/Container";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { useState, useEffect } from "react";
import "./AddGiftProducts.css";
import { Formik, Form } from "formik";
import { uploadImage, uploadImageWithoutSize } from "../../shared/api/user";
import { addProduct } from "../../shared/api/user";
import { useNavigate } from "react-router-dom";
import { inputLabelClasses } from "@mui/material/InputLabel";
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import { useTheme } from '@mui/material/styles';
import OutlinedInput from '@mui/material/OutlinedInput';
import Chip from '@mui/material/Chip';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import ImageList from '@mui/material/ImageList';
import ImageListItem from '@mui/material/ImageListItem';
import { CITY_NAMES } from '../../shared/constants/cities';

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

const sizeOptions = [
    'S',
    'M',
    'L',
    'XL',
    'XXL',
    '3/4-Y',
    '4/5-Y',
    '5/6-Y',
    '6/7-Y',
    '7/8-Y',
    '8/9-Y',
    '9/10-Y',
    '11/12-Y',
    '13/14-Y'
];

function getStyles(name, personName, theme) {
  return {
    fontWeight: personName.includes(name)
      ? theme.typography.fontWeightMedium
      : theme.typography.fontWeightRegular,
  };
}

const theme = createTheme();
export default function SignUp() {
  const [File, setFile] = React.useState();
  const [uploadedImage, setUploadedImage] = useState(null);
  const [city, setCity] = useState('');
  const [type, setType] = useState('');
  const [message, setMessage] = useState('');
  const [Loading, setLoading] = useState(true);
  const navigate = useNavigate();

  const [sizes, setSizes] = React.useState([]);
  const [sizeChartFile, setSizeChartFile] = useState(null);
  const [sizeChartPreview, setSizeChartPreview] = useState(null);
  const [pictureFiles, setPictureFiles] = useState([]);
  const [picturePreviews, setPicturePreviews] = useState([]);


const [localPercentage, setLocalPercentage] = useState(0);
const [intPercentage, setIntPercentage] = useState(0); // New state for International percentage

  const style = {
    "& .MuiOutlinedInput-root": {
      "&.Mui-focused fieldset": {
        borderColor: "#CB2704",
      },
    },
  };
  const theme = useTheme();
  const [personName, setPersonName] = React.useState([]);
  
  const [basePrice, setBasePrice] = useState(0);
  //const [percentage, setPercentage] = useState(0);
  const [calculatedPrice, setCalculatedPrice] = useState(0);
const [exchangeRates, setExchangeRates] = useState(null);


  const handleChangeCity = (event) => {
    const {
      target: { value },
    } = event;
    setPersonName(
      typeof value === 'string' ? value.split(',') : value,
    );
  };
// Handle sizes change
  const handleChangeSizes = (event) => {
    const {
      target: { value },
    } = event;
    setSizes(
      typeof value === 'string' ? value.split(',') : value,
    );
  };

   // Handle size chart upload
  const handleSizeChartFile = async (event) => {
    const file = event.target.files[0];
    if (file) {
      setSizeChartFile(file);
      const reader = new FileReader();
      reader.onload = () => {
        setSizeChartPreview(reader.result);
      };
      reader.readAsDataURL(file);
    }
  };

   // Handle multiple pictures upload
  const handlePictureFiles = async (event) => {
    const files = Array.from(event.target.files);
    if (files.length > 0) {
      const newFiles = [...pictureFiles, ...files];
      // Limit to 6 pictures
      if (newFiles.length > 6) {
        setMessage('You can upload maximum 6 pictures');
        return;
      }
      setPictureFiles(newFiles);

      // Create previews
      const newPreviews = [];
      files.forEach(file => {
        const reader = new FileReader();
        reader.onload = (e) => {
          newPreviews.push(e.target.result);
          if (newPreviews.length === files.length) {
            setPicturePreviews([...picturePreviews, ...newPreviews]);
          }
        };
        reader.readAsDataURL(file);
      });
    }
  };

  // Remove a picture
  const removePicture = (index) => {
    const newFiles = pictureFiles.filter((_, i) => i !== index);
    const newPreviews = picturePreviews.filter((_, i) => i !== index);
    setPictureFiles(newFiles);
    setPicturePreviews(newPreviews);
  };

  const handleFile = async (event) => {
    console.log(event);
    setFile(event.target.files[0]);
    console.log(File);
    const reader = new FileReader();
    reader.onload = () => {
      setUploadedImage(reader.result);
    };
    if (event.target.files[0]) {
      reader.readAsDataURL(event.target.files[0]);
    }
  };

  const selectCity = (event) => {
    setCity(event.target.value);
  };

  const selectType = (event) => {
    setType(event.target.value);
  };

  //   const init = async () => {
  // let user = await getMe();
  //   };
  //   useEffect(() => {
  //     init();
  //   }, []);

  useEffect(() => {
    const calculated = basePrice + (basePrice * localPercentage / 100);
    setCalculatedPrice(calculated);
  }, [basePrice, localPercentage]);

  useEffect(() => {
    const fetchExchangeRates = async () => {
      try {
        const res = await fetch("https://open.er-api.com/v6/latest/USD");
        const data = await res.json();
        if (data?.result === "success") {
          setExchangeRates(data.rates);
        }
      } catch (err) {
        console.error("Exchange rate fetch failed", err);
      }
    };
    fetchExchangeRates();
  }, []);

  // Calculate multi-currency prices whenever calculatedPrice or exchangeRates change
useEffect(() => {
  if (exchangeRates && basePrice > 0) {
    // Calculate international price using intPercentage
    const internationalPrice = basePrice + (basePrice * intPercentage / 100);
    
    console.log("Multi-currency prices calculated:", {
      priceUSD: (internationalPrice / exchangeRates.PKR).toFixed(2),
      priceCAD: (internationalPrice / (exchangeRates.PKR / exchangeRates.CAD)).toFixed(2),
      priceAED: (internationalPrice / (exchangeRates.PKR / exchangeRates.AED)).toFixed(2),
      priceAUD: (internationalPrice / (exchangeRates.PKR / exchangeRates.AUD)).toFixed(2),
      priceGBP: (internationalPrice / (exchangeRates.PKR / exchangeRates.GBP)).toFixed(2),
      priceSAR: (internationalPrice / (exchangeRates.PKR / exchangeRates.SAR)).toFixed(2),
      priceOMR: (internationalPrice / (exchangeRates.PKR / exchangeRates.OMR)).toFixed(2),
      priceKWD: (internationalPrice / (exchangeRates.PKR / exchangeRates.KWD)).toFixed(2),
      priceBHD: (internationalPrice / (exchangeRates.PKR / exchangeRates.BHD)).toFixed(2),
      priceQAR: (internationalPrice / (exchangeRates.PKR / exchangeRates.QAR)).toFixed(2),

    });
  }
}, [basePrice, intPercentage, exchangeRates]);

useEffect(() => {
    const calculated = basePrice + (basePrice * localPercentage / 100);
    setCalculatedPrice(calculated);
  }, [basePrice, localPercentage]);


  return (
    <ThemeProvider theme={theme}>
      <Container component="main" maxWidth="xs">
        <CssBaseline />
        <Box
          sx={{
            marginTop: 8,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <Typography
            sx={{ mt: 2, mb: 2, fontWeight: "600" }}
            component="h1"
            variant="h5"
          >
            Add Product
          </Typography>
          <Box sx={{ mt: 3 }}>
            <Grid container spacing={2}>
              <Formik
                initialValues={{
                  name: "",
                  description: "",
                  price: 0,
                  picture: "",
                  vendor: "",
                  city: "",
                  priceUSD: 0,
                  priceMYR: 0,
                  priceEUR: 0,
                  priceCAD: 0,
                  priceAED: 0,
                  priceAUD: 0,
                  priceGBP: 0,
                  priceSAR: 0,
                  priceOMR: 0,
                  priceKWD: 0,
                  priceBHD: 0,
                  priceQAR: 0,
                  type: "",
                  sizes: [],
                  sizeChart: "",
                  pictures: [],
                  basePrice: 0,        
                  localPercentage: 0,  
                  intPercentage: 0     
                }}
                onSubmit={(values, { setSubmitting }) => {
                  setTimeout(async () => {
                    if (File) {
                      const formData = new FormData();
                      formData.append("file", File);
                      let res = await uploadImageWithoutSize(formData);
                      values.picture = res.data.data.url;
                    }

                      // Upload size chart
                    if (sizeChartFile) {
                      const formData = new FormData();
                      formData.append("file", sizeChartFile);
                      let res = await uploadImageWithoutSize(formData);
                      values.sizeChart = res.data.data.url;
                    }

                    // Upload multiple pictures
                    const pictureUrls = [];
                    if (pictureFiles.length > 0) {
                      for (const file of pictureFiles) {
                        const formData = new FormData();
                        formData.append("file", file);
                        let res = await uploadImageWithoutSize(formData);
                        pictureUrls.push(res.data.data.url);
                      }
                    }
                    values.pictures = pictureUrls;

                    //values.price = parseFloat(calculatedPrice);
                    values.price = parseFloat(calculatedPrice);
                    values.basePrice = parseFloat(basePrice);        
                    values.localPercentage = parseFloat(localPercentage);
                    values.intPercentage = parseFloat(intPercentage);
                    values.city = personName;
                    values.sizes = sizes;

                    if (exchangeRates) {
                      const internationalPrice = basePrice + (basePrice * intPercentage / 100);
                      values.priceUSD = Number((internationalPrice / exchangeRates.PKR).toFixed(2));
                      values.priceMYR = Number((internationalPrice / (exchangeRates.PKR / exchangeRates.MYR)).toFixed(2));
                      values.priceEUR = Number((internationalPrice / (exchangeRates.PKR / exchangeRates.EUR)).toFixed(2));
                      values.priceCAD = Number((internationalPrice / (exchangeRates.PKR / exchangeRates.CAD)).toFixed(2));
                      values.priceAED = Number((internationalPrice / (exchangeRates.PKR / exchangeRates.AED)).toFixed(2));
                      values.priceAUD = Number((internationalPrice / (exchangeRates.PKR / exchangeRates.AUD)).toFixed(2));
                      values.priceGBP = Number((internationalPrice / (exchangeRates.PKR / exchangeRates.GBP)).toFixed(2));
                      values.priceSAR = Number((internationalPrice / (exchangeRates.PKR / exchangeRates.SAR)).toFixed(2));
                      values.priceOMR = Number((internationalPrice / (exchangeRates.PKR / exchangeRates.OMR)).toFixed(2));
                      values.priceKWD = Number((internationalPrice / (exchangeRates.PKR / exchangeRates.KWD)).toFixed(2));
                      values.priceBHD = Number((internationalPrice / (exchangeRates.PKR / exchangeRates.BHD)).toFixed(2));
                      values.priceQAR = Number((internationalPrice / (exchangeRates.PKR / exchangeRates.QAR)).toFixed(2));

                    }

                    values.type = type;
                    if (!type && !personName && !values.price && !values.picture) {
                      setMessage('All fields are required!');
                      setSubmitting(false);
                    } else {
                      setMessage('');
                      await addProduct(values);
                      setSubmitting(false);
                      navigate("/gifts");
                    }
                  }, 400);
                }}
              >
                {({ handleSubmit, handleChange, isSubmitting, values }) => (
                  <form
                    onSubmit={(e) => {
                      e.preventDefault();
                      handleSubmit();
                    }}
                  >
                    <Grid mb={3} item xs={12}>
                      <TextField
                        sx={style}
                        InputLabelProps={{
                          sx: {
                            [`&.${inputLabelClasses.shrink}`]: {
                              color: "#CB2704",
                            },
                          },
                        }}
                        fullWidth
                        id="name"
                        label="Product Name"
                        name="name"
                        autoComplete="text"
                        onChange={handleChange}
                      />
                    </Grid>
                    <Grid mb={3} item xs={12}>
                      <TextField
                        sx={style}
                        InputLabelProps={{
                          sx: {
                            [`&.${inputLabelClasses.shrink}`]: {
                              color: "#CB2704",
                            },
                          },
                        }}
                        fullWidth
                        id="description"
                        label="Description"
                        name="description"
                        autoComplete="text"
                        onChange={handleChange}
                      />
                    </Grid>
                      {/* New Input Fields */}
                      <Grid mb={2} item xs={12}>
                        <TextField
                        sx={style}
                        InputLabelProps={{
                          sx: {
                            [`&.${inputLabelClasses.shrink}`]: {
                              color: "#CB2704",
                            },
                          },
                        }}
                        fullWidth
                        id="basePrice"
                        label="Base Price"
                        name="basePrice"
                        type="number"
                        autoComplete="text"
                        value={basePrice}
                        onChange={(e) => setBasePrice(parseFloat(e.target.value) || 0)}
                      />
                    </Grid>

                    <Grid mb={2} item xs={12}>
                      <TextField
                        sx={style}
                        InputLabelProps={{
                          sx: {
                            [`&.${inputLabelClasses.shrink}`]: {
                              color: "#CB2704",
                            },
                          },
                        }}
                        fullWidth
                        id="localPercentage"
                        label="Percentage (%)"
                        name="percentage"
                        type="number"
                        autoComplete="text"
                        value={localPercentage}
                        onChange={(e) => setLocalPercentage(parseFloat(e.target.value) || 0)}
                        // inputProps={{
                        //   min: 0
                        // }}

                      />
                    </Grid>

                    {/* New International Percentage Field */}
                    <Grid mb={2} item xs={12}>
                      <TextField
                        sx={style}
                        InputLabelProps={{
                          sx: {
                            [`&.${inputLabelClasses.shrink}`]: {
                              color: "#CB2704",
                            },
                          },
                        }}
                        fullWidth
                        id="intPercentage"
                        label="International Percentage (%)"
                        name="intPercentage"
                        type="number"
                        autoComplete="text"
                        value={intPercentage}
                        onChange={(e) => setIntPercentage(parseFloat(e.target.value) || 0)}
                      />
                    </Grid>

                  <Grid mb={2} item xs={12}>
                    <TextField
                      sx={style}
                      InputLabelProps={{
                        sx: {
                          [`&.${inputLabelClasses.shrink}`]: {
                            color: "#CB2704",
                          },
                        },
                      }}
                      fullWidth
                      id="price"
                      label="Calculated Price"
                      name="price"
                      type="number"
                      autoComplete="text"
                      value={calculatedPrice}
                      InputProps={{
                        readOnly: true,
                      }}
                    />
                  </Grid>

    {/* Multi-Currency Fields */}
                    {exchangeRates && (
                      <>
                        <Grid mb={2} item xs={12}>
                          <TextField
                            sx={style}
                            InputLabelProps={{
                              sx: {
                                [`&.${inputLabelClasses.shrink}`]: {
                                  color: "#CB2704",
                                },
                              },
                            }}
                            fullWidth
                            id="priceUSD"
                            label="Price (USD)"
                            name="priceUSD"
                            type="number"
                            autoComplete="text"
                            value={exchangeRates ? ((basePrice + (basePrice * intPercentage / 100)) / exchangeRates.PKR).toFixed(2) : 0}
                            InputProps={{
                              readOnly: true,
                            }}
                          />
                        </Grid>

                        <Grid mb={2} item xs={12}>
                          <TextField
                            sx={style}
                            InputLabelProps={{
                              sx: {
                                [`&.${inputLabelClasses.shrink}`]: {
                                  color: "#CB2704",
                                },
                              },
                            }}
                            fullWidth
                            id="priceMYR"
                            label="Price (MYR)"
                            name="priceMYR"
                            type="number"
                            autoComplete="text"
                            value={exchangeRates ? ((basePrice + (basePrice * intPercentage / 100)) / (exchangeRates.PKR / exchangeRates.MYR)).toFixed(2) : 0}
                            InputProps={{
                              readOnly: true,
                            }}
                          />
                        </Grid>

                        <Grid mb={2} item xs={12}>
                          <TextField
                            sx={style}
                            InputLabelProps={{
                              sx: {
                                [`&.${inputLabelClasses.shrink}`]: {
                                  color: "#CB2704",
                                },
                              },
                            }}
                            fullWidth
                            id="priceEUR"
                            label="Price (EUR)"
                            name="priceEUR"
                            type="number"
                            autoComplete="text"
                            value={exchangeRates ? ((basePrice + (basePrice * intPercentage / 100)) / (exchangeRates.PKR / exchangeRates.EUR)).toFixed(2) : 0}
                            InputProps={{
                              readOnly: true,
                            }}
                          />
                        </Grid>

                        <Grid mb={2} item xs={12}>
                          <TextField
                            sx={style}
                            InputLabelProps={{
                              sx: {
                                [`&.${inputLabelClasses.shrink}`]: {
                                  color: "#CB2704",
                                },
                              },
                            }}
                            fullWidth
                            id="priceCAD"
                            label="Price (CAD)"
                            name="priceCAD"
                            type="number"
                            autoComplete="text"
                            value={exchangeRates ? ((basePrice + (basePrice * intPercentage / 100)) / (exchangeRates.PKR / exchangeRates.CAD)).toFixed(2) : 0}
                            InputProps={{
                              readOnly: true,
                            }}
                          />
                        </Grid>

                        <Grid mb={2} item xs={12}>
                          <TextField
                            sx={style}
                            InputLabelProps={{
                              sx: {
                                [`&.${inputLabelClasses.shrink}`]: {
                                  color: "#CB2704",
                                },
                              },
                            }}
                            fullWidth
                            id="priceAED"
                            label="Price (AED)"
                            name="priceAED"
                            type="number"
                            autoComplete="text"
                            value={exchangeRates ? ((basePrice + (basePrice * intPercentage / 100)) / (exchangeRates.PKR / exchangeRates.AED)).toFixed(2) : 0}
                            InputProps={{
                              readOnly: true,
                            }}
                          />
                        </Grid>

                        <Grid mb={2} item xs={12}>
                          <TextField
                            sx={style}
                            InputLabelProps={{
                              sx: {
                                [`&.${inputLabelClasses.shrink}`]: {
                                  color: "#CB2704",
                                },
                              },
                            }}
                            fullWidth
                            id="priceAUD"
                            label="Price (AUD)"
                            name="priceAUD"
                            type="number"
                            autoComplete="text"
                            value={exchangeRates ? ((basePrice + (basePrice * intPercentage / 100)) / (exchangeRates.PKR / exchangeRates.AUD)).toFixed(2) : 0}
                            InputProps={{
                              readOnly: true,
                            }}
                          />
                        </Grid>

                        <Grid mb={2} item xs={12}>
                          <TextField
                            sx={style}
                            InputLabelProps={{
                              sx: {
                                [`&.${inputLabelClasses.shrink}`]: {
                                  color: "#CB2704",
                                },
                              },
                            }}
                            fullWidth
                            id="priceGBP"
                            label="Price (GBP)"
                            name="priceGBP"
                            type="number"
                            autoComplete="text"
                            value={exchangeRates ? ((basePrice + (basePrice * intPercentage / 100)) / (exchangeRates.PKR / exchangeRates.GBP)).toFixed(2) : 0}
                            InputProps={{
                              readOnly: true,
                            }}
                          />
                        </Grid>

                        <Grid mb={2} item xs={12}>
                          <TextField
                            sx={style}
                            InputLabelProps={{
                              sx: {
                                [`&.${inputLabelClasses.shrink}`]: {
                                  color: "#CB2704",
                                },
                              },
                            }}
                            fullWidth
                            id="priceSAR"
                            label="Price (SAR)"
                            name="priceSAR"
                            type="number"
                            autoComplete="text"
                            value={exchangeRates ? ((basePrice + (basePrice * intPercentage / 100)) / (exchangeRates.PKR / exchangeRates.SAR)).toFixed(2) : 0}
                            InputProps={{
                              readOnly: true,
                            }}
                          />
                        </Grid>

                         <Grid mb={2} item xs={12}>
                          <TextField
                            sx={style}
                            InputLabelProps={{
                              sx: {
                                [`&.${inputLabelClasses.shrink}`]: {
                                  color: "#CB2704",
                                },
                              },
                            }}
                            fullWidth
                            id="priceOMR"
                            label="Price (OMR)"
                            name="priceOMR"
                            type="number"
                            autoComplete="text"
                            value={exchangeRates ? ((basePrice + (basePrice * intPercentage / 100)) / (exchangeRates.PKR / exchangeRates.OMR)).toFixed(3) : 0}
                            InputProps={{
                              readOnly: true,
                            }}
                          />
                        </Grid>

                        <Grid mb={2} item xs={12}>
                          <TextField
                            sx={style}
                            InputLabelProps={{
                              sx: {
                                [`&.${inputLabelClasses.shrink}`]: {
                                  color: "#CB2704",
                                },
                              },
                            }}
                            fullWidth
                            id="priceKWD"
                            label="Price (KWD)"
                            name="priceKWD"
                            type="number"
                            autoComplete="text"
                            value={exchangeRates ? ((basePrice + (basePrice * intPercentage / 100)) / (exchangeRates.PKR / exchangeRates.KWD)).toFixed(3) : 0}
                            InputProps={{
                              readOnly: true,
                            }}
                          />
                        </Grid>

                        <Grid mb={2} item xs={12}>
                          <TextField
                            sx={style}
                            InputLabelProps={{
                              sx: {
                                [`&.${inputLabelClasses.shrink}`]: {
                                  color: "#CB2704",
                                },
                              },
                            }}
                            fullWidth
                            id="priceBHD"
                            label="Price (BHD)"
                            name="priceBHD"
                            type="number"
                            autoComplete="text"
                            value={exchangeRates ? ((basePrice + (basePrice * intPercentage / 100)) / (exchangeRates.PKR / exchangeRates.BHD)).toFixed(3) : 0}
                            InputProps={{
                              readOnly: true,
                            }}
                          />
                        </Grid>

                        <Grid mb={2} item xs={12}>
                          <TextField
                            sx={style}
                            InputLabelProps={{
                              sx: {
                                [`&.${inputLabelClasses.shrink}`]: {
                                  color: "#CB2704",
                                },
                              },
                            }}
                            fullWidth
                            id="priceQAR"
                            label="Price (QAR)"
                            name="priceQAR"
                            type="number"
                            autoComplete="text"
                            value={exchangeRates ? ((basePrice + (basePrice * intPercentage / 100)) / (exchangeRates.PKR / exchangeRates.QAR)).toFixed(2) : 0}
                            InputProps={{
                              readOnly: true,
                            }}
                          />
                        </Grid>
                      </>
                    )}
                    <Grid mb={2} item xs={12}>
                      <TextField
                        sx={style}
                        InputLabelProps={{
                          sx: {
                            [`&.${inputLabelClasses.shrink}`]: {
                              color: "#CB2704",
                            },
                          },
                        }}
                        fullWidth
                        id="vendor"
                        label="Vendor"
                        name="vendor"
                        value={values.vendor}
                        type="text"
                        autoComplete="text"
                        onChange={handleChange}
                      />
                    </Grid>
                    <Box mb={2} sx={{ minWidth: 120 }}>
                      <FormControl fullWidth>
                        <InputLabel id="demo-simple-select-label">City</InputLabel>
                        <Select
                          labelId="demo-multiple-name-label"
                          id="demo-multiple-name"
                          multiple
                          value={personName}
                          onChange={handleChangeCity}
                          input={<OutlinedInput label="Name" />}
                          MenuProps={MenuProps}
                        >
                          {CITY_NAMES.map((name) => (
                            <MenuItem
                              key={name}
                              value={name}
                              style={getStyles(name, personName, theme)}
                            >
                              {name}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </Box>

                    <Box sx={{ minWidth: 120 }}>
                      <FormControl fullWidth>
                        <InputLabel id="demo-simple-select-label">Type</InputLabel>
                        <Select
                          labelId="demo-simple-select-label"
                          id="demo-simple-select"
                          value={type}
                          label="City"
                          onChange={selectType}
                        >
                          <MenuItem value={"FLOWERS"}>FLOWERS</MenuItem>
                          <MenuItem value={"CHOCOLATES"}>CHOCOLATES</MenuItem>
                          <MenuItem value={"SWEETS"}>SWEETS</MenuItem>
                          <MenuItem value={"CHOCOLATES_FLOWERS"}>CHOCOLATES_FLOWERS</MenuItem>
                          <MenuItem value={"BASKET_FLOWERS"}>BASKET_FLOWERS</MenuItem>
                          <MenuItem value={"CHOCOLATES_BOUQUET"}>CHOCOLATES_BOUQUET</MenuItem>
                          <MenuItem value={"CAKE_FLOWERS"}>CAKE_FLOWERS</MenuItem>
                          <MenuItem value={"BASKET"}>BASKET</MenuItem>
                          <MenuItem value={"CAKES"}>CAKES</MenuItem>
                          <MenuItem value={"PERFUMES"}>PERFUMES</MenuItem>
                          <MenuItem value={"WALLETS"}>WALLETS</MenuItem>
                          <MenuItem value={"WOMEN_CROSSBODY_BAGS"}>WOMEN_CROSSBODY_BAGS</MenuItem>
                          <MenuItem value={"WATCHES"}>WATCHES</MenuItem>
                          <MenuItem value={"CLOTHING"}>CLOTHING</MenuItem>
                          <MenuItem value={"MEN_CLOTHING"}>MEN CLOTHING</MenuItem>
                          <MenuItem value={"WOMEN_CLOTHING"}>WOMEN CLOTHING</MenuItem>
                          <MenuItem value={"KIDS_CLOTHING"}>KIDS CLOTHING</MenuItem>
                        </Select>
                      </FormControl>
                    </Box>

 {/* Sizes Selection - NEW */}
                      <Grid item xs={12}>
                        <FormControl fullWidth>
                          <InputLabel id="sizes-label">Sizes</InputLabel>
                          <Select
                            labelId="sizes-label"
                            id="sizes-select"
                            multiple
                            value={sizes}
                            onChange={handleChangeSizes}
                            input={<OutlinedInput label="Sizes" />}
                            MenuProps={MenuProps}
                            renderValue={(selected) => (
                              <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                                {selected.map((value) => (
                                  <Chip key={value} label={value} size="small" />
                                ))}
                              </Box>
                            )}
                          >
                            {sizeOptions.map((size) => (
                              <MenuItem
                                key={size}
                                value={size}
                                style={getStyles(size, sizes, theme)}
                              >
                                {size}
                              </MenuItem>
                            ))}
                          </Select>
                        </FormControl>
                      </Grid>

                          {/* Main Image */}
                      <Grid item xs={12}>
                        <Typography variant="subtitle1" gutterBottom>
                          Main Product Image
                        </Typography>
                        <div style={{ textAlign: "center", marginBottom: "10px" }}>
                          {uploadedImage && (
                            <img
                              src={uploadedImage}
                              alt="Main Product"
                              style={{
                                maxWidth: "100%",
                                maxHeight: "200px",
                                borderRadius: "10px",
                              }}
                            />
                          )}
                        </div>

                        <Button
                          variant="contained"
                          component="label"
                          fullWidth
                          sx={{
                            background: '#CB2704', 
                            "&:hover": { background: "red" }
                          }}
                        >
                          Upload Main Image
                          <input type="file" onChange={handleFile} hidden />
                        </Button>
                      </Grid>

                      {/* Size Chart Image - NEW */}
                      <Grid item xs={12}>
                        <Typography variant="subtitle1" gutterBottom sx={{ mt: 2 }}>
                          Size Chart Image
                        </Typography>
                        <div style={{ textAlign: "center", marginBottom: "10px" }}>
                          {sizeChartPreview && (
                            <img
                              src={sizeChartPreview}
                              alt="Size Chart"
                              style={{
                                maxWidth: "100%",
                                maxHeight: "200px",
                                borderRadius: "10px",
                              }}
                            />
                          )}
                        </div>
                        <Button
                          variant="contained"
                          component="label"
                          fullWidth
                          sx={{
                            background: '#CB2704', 
                            "&:hover": { background: "red" }
                          }}
                        >
                          Upload Size Chart
                          <input type="file" onChange={handleSizeChartFile} hidden />
                        </Button>
                      </Grid>

                      {/* Multiple Pictures - NEW */}
                      <Grid item xs={12}>
                        <Typography variant="subtitle1" gutterBottom sx={{ mt: 2 }}>
                          Additional Pictures (Max 6)
                        </Typography>

                        {/* Picture Previews */}
                        {picturePreviews.length > 0 && (
                          <ImageList sx={{ width: '100%', height: 'auto' }} cols={3} rowHeight={120}>
                            {picturePreviews.map((preview, index) => (
                              <ImageListItem key={index} sx={{ position: 'relative' }}>
                                <img
                                  src={preview}
                                  alt={`Product ${index + 1}`}
                                  style={{ height: 120, width: '100%', objectFit: 'cover' }}
                                />
                                <IconButton
                                  size="small"
                                  sx={{
                                    position: 'absolute',
                                    top: 5,
                                    right: 5,
                                    backgroundColor: 'rgba(255,255,255,0.8)',
                                    '&:hover': { backgroundColor: 'rgba(255,255,255,0.9)' }
                                  }}
                                  onClick={() => removePicture(index)}
                                >
                                  <CloseIcon fontSize="small" />
                                </IconButton>
                              </ImageListItem>
                            ))}
                          </ImageList>
                        )}

                        {pictureFiles.length < 6 && (
                          <Button
                            variant="contained"
                            component="label"
                            fullWidth
                            sx={{
                              mt: 2,
                              background: '#CB2704', 
                              "&:hover": { background: "red" }
                            }}
                          >
                            Upload Additional Pictures
                            <input 
                              type="file" 
                              onChange={handlePictureFiles} 
                              hidden 
                              multiple 
                              accept="image/*"
                            />
                          </Button>
                        )}
                      </Grid>

                    {/* <div style={{ textAlign: "center", marginTop: "20px" }}>
                      {uploadedImage && (
                        <img
                          src={uploadedImage}
                          alt="Uploaded"
                          style={{
                            maxWidth: "100%",
                            maxHeight: "200px",
                            borderRadius: "10px",
                          }}
                        />
                      )}
                    </div>

                    {message && <div style={{ color: '#CB2704' }}>{message}</div>} */}

                    {/* <Button
                      variant="contained"
                      component="label"
                      fullWidth
                      sx={{
                        mt: 3,
                        mb: 1,
                        background: '#CB2704', "&:hover": { background: "red" }
                      }}
                    >
                      Upload Image
                      <input type="file" onChange={handleFile} hidden />
                    </Button> */}

                    <Button
                      type="submit"
                      disabled={isSubmitting}
                      fullWidth
                      variant="contained"
                      sx={{
                        mt: 2,
                        mb: 2,
                        background: '#CB2704', "&:hover": { background: "red" }
                      }}
                    >
                      Submit
                    </Button>
                  </form>
                )}
              </Formik>
            </Grid>
          </Box>
        </Box>
      </Container>
    </ThemeProvider>
  );
}
